import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import { enregistrerProjectIdUrl } from '../../../services/actions/interfaceClient';
import S from './Widget.module.scss';
import pin from '../../../ressources/accueil/fOn.png';

const WidgetProjets = ({ projects = [], loading = false }) => {
  const dispatch = useDispatch();
  const hasProjects = projects && projects.length > 0;

  return (
    <div className={[S.widget, S.widgetSmall].join(' ')}>
      <div className={S.dashboardWidgetHeader}>
        <h3 className={S.dashboardWidgetTitle}>
          {checkMot('Mes projets favoris : ')}
        </h3>
      </div>
      <div className={S.widgetContent}>
        {loading && !hasProjects ? (
          <div className={S.widgetLoadingState}>
            <div className={S.widgetLoadingSpinner} />
            <span className={S.widgetLoadingText}>
              {checkMot('chargement_en_cours')}
            </span>
          </div>
        ) : hasProjects ? (
          <ul className={S.projectList}>
            {projects.map((project) => (
              <li key={project.project_id} className={S.projectItem}>
                <span className={S.projectIcon}>
                  <img src={pin} alt="Favori" />
                </span>
                <Link
                  to={`/${project.project_id}`}
                  className={S.projectLink}
                  onClick={() =>
                    dispatch(enregistrerProjectIdUrl(project.project_id))
                  }
                >
                  {project.project_name}
                </Link>
              </li>
            ))}
          </ul>
        ) : (
          <div className={S.emptyState}>
            <p className={S.emptyText}>{checkMot('aucun_projet_favori')}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default WidgetProjets;
